module.exports = __webpack_public_path__ + "static/idea-f22100f0abf1e113c52c3ae29f0075b2.png";